<template>
    <div>
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg4 pr-6 pl-6>
            <v-layout row wrap justify-end>
              <v-menu
                  v-model="menuStart"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                      <v-text-field
                      v-model="computedStartDateFormatted"
                      label="Từ ngày"
                      hint="DD-MM-YYYY"
                      persistent-hint
                      prepend-icon="fa-calendar-alt"
                      readonly
                      v-on="on"
                      ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
              </v-menu>
            </v-layout>
          </v-flex>
          <v-flex lg4 pr-6>
            <v-layout row wrap justify-end>
              <v-menu
                  v-model="menuEnd"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                      <v-text-field
                      v-model="computedEndDateFormatted"
                      label="Đến ngày"
                      hint="DD-MM-YYYY"
                      persistent-hint
                      prepend-icon="fa-calendar-alt"
                      readonly
                      v-on="on"
                      ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
              </v-menu>
            </v-layout>
          </v-flex>
          <v-flex lg4 pr-6>
              <v-btn @click="filter_data" color="#3480c1" outlined>Xem</v-btn>
          </v-flex>
          <v-flex lg12 v-if="items">
            <v-data-table :headers="headers" :items="items" :server-items-length="items.length" :loading="loading">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ item.ReportDate | display_date('DD-MM-YYYY')}}</td>
                        <td class="text-end">{{ item.FeeBuy | currency}}</td>
                        <td class="text-end">{{ item.ProductAmount | currency}}</td>
                        <td class="text-end" v-if="adminRole">
                            <v-edit-dialog :return-value.sync="item.ExchangeAmount" large lazy persistent @save="saveItem(item)">
                            <div>{{ item.ExchangeAmount | currency}}</div>
                            <template v-slot:input>
                                <v-text-field v-model="item.ExchangeAmount" type="number" step="1" label="Chênh lệch tỷ giá" single-line autofocus></v-text-field>
                            </template>
                            </v-edit-dialog>
                        </td>
                        <td class="text-end" v-else>{{ item.ExchangeAmount | currency}}</td>
                        <td class="text-end" v-if="adminRole">
                            <v-edit-dialog :return-value.sync="item.WeightAmount" large lazy persistent @save="saveItem(item)">
                            <div>{{ item.WeightAmount | currency}}</div>
                            <template v-slot:input>
                                <v-text-field v-model="item.WeightAmount" type="number" step="1" label="Tiền vận chuyển" single-line autofocus></v-text-field>
                            </template>
                            </v-edit-dialog>
                        </td>
                        <td class="text-end" v-else>{{ item.WeightAmount | currency}}</td>
                        <td class="text-end">{{ item.TotalRevenue | currency}}</td>
                    </tr>
                </template>
                <template v-slot:body.append v-if="summary">
                    <tr>
                        <td class="font-weight-bold">TỔNG</td>
                        <td class="text-end font-weight-bold">{{summary.FeeBuy | currency}}</td>
                        <td class="text-end font-weight-bold">{{summary.ProductAmount | currency}}</td>
                        <td class="text-end font-weight-bold">{{summary.ExchangeAmount | currency}}</td>
                        <td class="text-end font-weight-bold">{{summary.WeightAmount | currency}}</td>
                        <td class="text-end font-weight-bold">{{summary.TotalRevenue | currency}}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        </v-layout>
      </v-container>
    </div>
  </template>
  <script>
  import { mapState } from "vuex";
  import configs from "@/configs";
  import _ from "lodash";
  import moment from "moment"
  export default {
      data() {
          return {
                viewName: "thong-ke-loi-nhuan-mua-ho",
                feeship_type_list: configs.FEESHIP_TYPE_LIST,
                dateRange: {
                    startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                    endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
                },
                menuStart: false,
                menuEnd: false,
                headers: [
                    {
                        text: "Ngày",
                        value: "ReportDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "Phí dịch vụ",
                        value: "FeeBuy",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tiền mặc cả",
                        value: "ProductAmount",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Chênh tỷ giá",
                        value: "ExchangeAmount",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tiền vận chuyển",
                        value: "WeightAmount",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Lợi nhuận",
                        value: "TotalRevenue",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    }
                ]
          };
      },
      computed: {
        ...mapState({
            items: state => state.analytic.revenue_report,
            loading: state => state.analytic.loading,
        }),
        summary() {
            var ret = {
                'FeeBuy': _.sumBy(this.items, 'FeeBuy'),
                'ProductAmount': _.sumBy(this.items, 'ProductAmount'),
                'ExchangeAmount': _.sumBy(this.items, 'ExchangeAmount'),
                'WeightAmount': _.sumBy(this.items, 'WeightAmount'),
                'TotalRevenue': _.sumBy(this.items, 'TotalRevenue'),
            };
            return ret;
        },
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        }
      },
      methods: {
            filter_data: function () {
                var param = {
                    startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                    endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
                };
                this.$store.dispatch("analytic/getRevenueReport", param);
            },
            saveItem(item) {
                this.$store.dispatch("analytic/setRevenueReport", {
                    data: item,
                    id: 999
                });
            },
      },
      mounted() {
          this.filter_data();
          this.$root.$emit('REQUEST_ROOT_OPTION', {});
          this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
      },
      beforeDestroy() {
          this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
      }
  };
  </script>